import React from 'react'
import { Col } from 'reactstrap'
import AssessDashSubtestResults from '../AssessDashSubtestResults';
import IncompleteSubtestCard from './IncompleteSubtestCard';

// A subtest card on the dashboard. Displays a different component
// depending on if subtest is complete or not.
export default function SubtestCard ({
  title,
  subtest,
  nodes,
  userAssessmentId,
  groupUAId,
  isStudent,
  assessmentId,
  selectedGroupUA,
  selectedStudent,
  user,
  groupUA,
  userAssessment,
  resume,
  complete,
  scoring,
  scoringCompare,
  xs, sm, md, lg, xl,
  isAssessmentInitializing,
  isCompare,
  sortedSubtestsCompare,
  test1,
  test2,
  isSwap,
  previousTest,
  year,
  licenseExpired
}) {
  return (
    <Col {...{ xs, sm, md, lg, xl, }}>
      {complete &&
        <AssessDashSubtestResults 
          sub={true}
          title={title}
          subtest={subtest}
          scoringCompare = {scoringCompare}
          byNodeScoring={scoring && scoring.byNode[subtest.setId]}
          bySubtestScoring={scoring && scoring.bySubtest[subtest.setId]}
          nodes={nodes}
          userAssessmentId={userAssessmentId}
          groupUAId={groupUAId}
          isStudent={isStudent}
          assessmentId={assessmentId}
          selectedGroupUA={selectedGroupUA}
          selectedStudent={selectedStudent}
          user={user}
          groupUA={groupUA}
          userAssessment={userAssessment}
          isAssessmentInitializing={isAssessmentInitializing}
          byNodeScoringCompare =  {scoringCompare ? scoringCompare.byNode[subtest.setId] : null}
          bySubtestScoringComparing = {scoringCompare ? scoringCompare.bySubtest[subtest.setId] : null}
          isCompare = {isCompare}
          test1 = {test1}
          test2 = {test2}
          isSwap = {isSwap}
        />
      }
      {!complete && 
        <IncompleteSubtestCard 
          title={title}
          subtest={subtest}
          resume={resume}
          userAssessmentId={userAssessmentId}
          groupUAId={groupUAId}
          isStudent={isStudent}
          selectedStudent={selectedStudent}
          groupUA={groupUA}
          userAssessment={userAssessment}
          assessmentId={assessmentId}
          previousTest={previousTest}
          year={year}
          licenseExpired={licenseExpired}
        />
      }
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/SubtestCard.js